export default {"src":"/_next/static/media/Ellipse 9.5e86fb7a.svg","height":59,"width":59,"blurWidth":0,"blurHeight":0};